module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class="phx-menu-separator" role="separator"><span class="ui-corner-all">'+
((__t=(nom))==null?'':__t)+
'</span></li>';
}
return __p;
};
